import { AxiosInstance } from 'axios';
import {
  OrderRelatedResponse,
  OrderResponse,
  OrderSummary,
} from '@/api/documents/documents.types.ts';
import { PaginatedResult } from '@/api/common/common.types.ts';

export const createDocumentsApi = (api: AxiosInstance) => ({
  getOrderSummaries: (
    businessPartnerId: number,
    page: number,
    search?: string,
    sortBy?: string,
    sortDir?: 'asc' | 'desc',
  ) =>
    api.get<PaginatedResult<OrderSummary>>(
      `/v1/documents/orders/${businessPartnerId}`,
      {
        params: {
          page,
          search,
          sortBy,
          sortDir,
        },
      },
    ),
  getOrder: (businessPartnerId: number, orderId: number) =>
    api.get<OrderResponse>(`/v1/documents/${businessPartnerId}/${orderId}`),
  getOrderRelated: (businessPartnerId: number, orderId: number) =>
    api.get<OrderRelatedResponse>(
      `/v1/documents/${businessPartnerId}/${orderId}/related`,
    ),
});
